<template>
  <div class="common">
    <search-form :formConfig="formConfig" :source="searchData" @search="search">
      <template slot="btns" v-if="+msgStCd===0">
        <button-load class="search-btn-item btn-blue-line" lable="设为已读" @clickHandle="readList" :disabled="selectedRows.length==0" />
      </template>
    </search-form>
    <div class="table-common">
      <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData" :pagination="pagination" :loading="loading"
               @change="handleTableChange" bordered :scroll="columns.length>10?{ x: '100%' }:{}" :locale="{emptyText: '暂无数据'}"
               :row-selection="tableSelect">
        <template slot="msgCntnt" slot-scope="text">
          <div class="ellipsis">
            {{getText(text)}}
          </div>
        </template>
        <template slot="createTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd HH:MM')}}</template>
        <template slot="operation" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
        </template>
      </a-table>
    </div>
    <transferPdfView ref="transferPdfView" />
    <a-modal title="通知详情" v-model="notificationModal" width="80%" :footer="null" @cancel="notificationModal = false" destroyOnClose>
      <a-form-model ref="ruleFormImport" :model="notificationFormData" :label-col="{ span: 8 }" :wrapper-col="{ span: 13 }">

        <a-form-model-item label="标题" prop="importType" style="margin-bottom:8px;">
          <a-input v-model="notificationFormData.msgTtl" readonly placeholder="请输入" />

        </a-form-model-item>
        <a-form-model-item label="内容" prop="msgCntnt" style="margin-bottom:8px;">
          <!-- <a-input v-model="notificationFormData.tenantObj.key" disabled /> -->
          <a-textarea v-model="notificationFormData.msgCntnt" placeholder="" :rows="4" readonly />
        </a-form-model-item>

      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { transferNoticeList, transferUpdateMsgStCd } from '@/api/message.js';
import transferPdfView from './pdf-view.vue';
export default {
  props: {
    // 阅读状态 1：已读、0：未读
    msgStCd: {
      type: [Number, String]
    }
  },
  components: { transferPdfView },
  data() {
    return {
      notificationModal: false,
      notificationFormData: {},
      loading: false,
      searchData: {
        msgTtl: undefined,
        msgCntnt: undefined,
        dateRange: []
      },
      formConfig: [
        {
          prop: 'msgTtl',
          type: 'input',
          label: '通知标题'
        },
         {
          prop: 'expdId',
          type: 'input',
          label: '祺信编号'
        },
        {
          prop: 'msgCntnt',
          type: 'input',
          label: '通知内容'
        },
        {
          prop: 'dateRange',
          type: 'dateRange',
          label: '到期日期'
        }
      ],
      columns: [
        {
          title: '标题',
          dataIndex: 'msgTtl',
          width: '240px'
        },
        {
          title: '内容',
          dataIndex: 'msgCntnt',
          ellipsis: true,
          scopedSlots: { customRender: 'msgCntnt' }
        },
        {
          title: '接收时间',
          dataIndex: 'createTime',
          width: '130px',
          sorter: true,
          scopedSlots: { customRender: 'createTime' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '70px',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: 'createTime',
        sortOrder: 'desc',
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showTotal: (total) => {
          return `共 ${total} 条`;
        }
      },
      selectedRowKeys: [],
      selectedRows: []
    };
  },
  computed: {
    tableSelect() {
      if (this.msgStCd == 0) {
        return {
          type: 'checkbox',
          selectedRowKeys: this.selectedRowKeys,
          selectedRows: this.selectedRows,
          onChange: this.onTableChange
        };
      }
      return null;
    }
  },
  methods: {
    search(data) {
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      const params = {
        orderBy: this.pagination.sortField ? `${this.pagination.sortField} ${this.pagination.sortOrder == 'ascend' ? 'asc' : 'desc'}` : '',
        msgStCd: this.msgStCd,
        msgTtl: this.searchData.msgTtl,
        msgCntnt: this.searchData.msgCntnt,
        rcvbExDatStart: this.searchData.dateRange[0],
        rcvbExDatEnd: this.searchData.dateRange[1],
        expdId: this.searchData.expdId,
      };
      transferNoticeList(params)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.grid.list;
          this.selectedRowKeys = [];
          this.selectedRows = [];
          this.$store.dispatch('home/getMessageCount');
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onTableChange(selectedRows, data, data2) {
      //表格选择回调
      this.selectedRowKeys = selectedRows;
      this.selectedRows = data;
    },
    handleTableChange(pagination, filters, sorter) {
      //表格排序回调
      this.pagination = {
        current: pagination.current,
        pageSize: pagination.pageSize,
        sortField: sorter.field,
        sortOrder: sorter.order,
        total: this.pagination.total || 0
      };
      this.getTableData();
    },
    getText(html) {
      if (html) {
        return html.replace(/<(.*?)>/gi, ' ');
      }
    },
    readList(btn) {
      btn.closeLoad();
      const self = this;
      this.$confirm({
        title: '提示',
        content: '是否确认设为已读',
        onOk() {
          transferUpdateMsgStCd({
            ids: self.selectedRowKeys.join(',')
          })
            .then((res) => {
              self.$message.success('操作成功');
              self.search();
            })
            .catch((err) => {});
        },
        onCancel() {}
      });
    },
    toPageDetail(data) {
      if (['TRANSFER'].includes(data.msgTpCd)) {
        this.$refs.transferPdfView.open({
          msgStCd: data.msgStCd,
          id: data.id,
          title: data.msgTtl,
          expdId: data.expdId,
          msgTpCd: data.msgTpCd
        });
      } else {
        this.notificationModal = true;
        this.notificationFormData = { ...data, msgCntnt: this.getText(data.msgCntnt) };
      }
    }
  },
  created() {
    this.getTableData();
  },
  mounted() {}
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/message/transferNotice/list.vue